import toFixedValue from 'app/common/lib/toFixedValue'
import { ProductDataDto } from '../types'
import { Entity } from './types'
import { extractDateAndNameFromColumnKey } from './create-column-keys'

export const createData = ({
  data,
  columnKeysMain,
}: {
  data: ProductDataDto
  columnKeysMain: Array<string>
}) => {
  const commonItems = data.reduce(
    (acc, { title, items }) => {
      return [
        ...acc,
        // заголововок продукции
        {
          rowKey: `${title}-${Entity.IsOnlyTitle}`,
          rowData: columnKeysMain.reduce(
            (acc, key) => {
              acc[key] = {
                columnKey: key,
                value: '',
                type: 'isOnlyTitle',
              }
              return acc
            },
            {
              [Entity.Title]: {
                columnKey: Entity.Title as const,
                value: title,
                type: 'isOnlyTitle',
              },
              [Entity.TotalCount]: {
                columnKey: Entity.TotalCount as const,
                value: '',
                type: 'isOnlyTitle',
              },
              [Entity.TotalSum]: {
                columnKey: Entity.TotalSum as const,
                value: '',
                type: 'isOnlyTitle',
              },
            } as Record<
              Entity,
              { columnKey: string; value: string; type?: 'isOnlyTitle' | 'isTotal' }
            >,
          ),
        },
        // продукты
        ...items.map(({ title: productTitle, total: { count, sum }, data_by_date: dataByDate }) => {
          return {
            rowKey: `${title}-${productTitle}`,
            rowData: columnKeysMain.reduce(
              (acc, key) => {
                const [name, date] = extractDateAndNameFromColumnKey(key)
                const itemData = dataByDate[date]
                if (!itemData) {
                  console.warn(`Не найдено поле ${date} в 'data_by_date' в данных отчета`)
                  return acc
                }
                acc[key] = {
                  columnKey: key,
                  value:
                    name === Entity.DateCount ? String(itemData.count) : toFixedValue(itemData.sum),
                }
                return acc
              },
              {
                [Entity.Title]: {
                  columnKey: Entity.Title as const,
                  value: productTitle,
                },
                [Entity.TotalCount]: {
                  columnKey: Entity.TotalCount as const,
                  value: count || count === 0 ? String(count) : '',
                },
                [Entity.TotalSum]: {
                  columnKey: Entity.TotalSum as const,
                  value: toFixedValue(sum),
                },
              } as Record<
                Entity,
                { columnKey: string; value: string; type?: 'isOnlyTitle' | 'isTotal' }
              >,
            ),
          }
        }),
      ]
    },
    [] as Array<{
      rowKey: string
      rowData: Record<
        Entity,
        { columnKey: string; value: string; type?: 'isOnlyTitle' | 'isTotal' }
      >
    }>,
  )

  return commonItems
}
